export default __webpack_public_path__ + "static/media/stefan-footer-image.422e5435.png";